import StatusNew from "../common-components/status-new";
import { TaskActions } from "../common-components/task-actions";
import TaskGridViewMembers from "../common-components/task-grid-view-members";
import { FluentTooltip } from "../../../../../components/FluentUI/Fluent-Tooltip";
import PriorityNew from "../common-components/priority-new";
import LastActivity from "../common-components/last-activity";
import Progress from "../common-components/progress";
import Owner from "../common-components/owner";
import {
  DateFormatBasedOnDepartment,
  DateStringFormatBasedOnDepartment,
} from "../../../../../util/time-helpers";
import PriorityFluentNew from "../../../../../components/priority/priority-fluent-new";

export const initialDataState = {
  sort: [],
  take: 25,
  skip: 0,
  filter: {
    logic: "and",
    filters: [],
  },
};

export const FieldTypes = Object.freeze({
  ShortTextEntry: "Short Text Entry",
  LongTextEntry: "Long Text Entry",
  NumericInteger: "Numeric (Integer)",
  NumericDecimal: "Numeric (Decimal)",
  Dropdown: "Dropdown",
  Date: "Date",
  TimeDuration: "Time Duration",
  Checkbox: "Checkbox",
  Toggle: "Toggle",
  Radio: "Radio Buttons",
  Table: "Table",
});

const MapTaskObject = (taskToBekModified, dataTimeFormat) => {
  const { task } = taskToBekModified;

  let parsedData = { ...JSON.parse(task) };

  Object.entries(parsedData).forEach(([key, field]) => {
    if (field.Data !== null && field.Data !== "") {
      if (field.ColumnType === FieldTypes.Date) {
        field.Data = DateFormatBasedOnDepartment(field.Data, dataTimeFormat);
      } else if (field.ColumnType === FieldTypes.NumericInteger) {
        field.Data = parseInt(field.Data);
      } else if (field.ColumnType === FieldTypes.NumericDecimal) {
        field.Data = parseFloat(field.Data);
      }
    }
  });

  return parsedData;
};

export const ModifyConfigurableTaskData = (task, dataTimeFormat) => {
  let modifiedTask = task?.map((task) => MapTaskObject(task, dataTimeFormat));
  return modifiedTask;
};

export const CustomCell = (column, { dataItem }) => {
  if (dataItem[column]?.ColumnType === FieldTypes.Date) {
    return CustomDateCell(dataItem[column]); // Libro
  } else if (column === "Assigned Members") { // Libro
    return CustomAssignedMembersCell(dataItem);
  } else if (column === "Members" || column === "Team") { // S&D - handle both Members and Team
    return CustomMembersCell(dataItem, column);
  } else if (column === "Owner") { // S&D
    return CustomOwnerCell(dataItem);
  } else if (column === "LastActivityObject" && dataItem.LastActivityObject && typeof dataItem.LastActivityObject?.Data === "object") { // S&D
    return CustomLastActivityCell(dataItem.LastActivityObject?.Data);
  } else if (column === "Progress") { // S&D
    return CustomProgressCell(dataItem);
  } else if (column === "Status") {
    return CustomStatusCell(dataItem);
  } else if (column === "Priority") {
    return CustomPriorityCell(dataItem);
  } else {
    return (
      <FluentTooltip
        target={<td className="k-table-td">{dataItem[column]?.Data}</td>}
        text={dataItem[column]?.Data}
      />
    );
  }
};

const CustomStatusCell = (dataItem) => {
  return (
    <td className="k-table-td td-status">
      <StatusNew status={dataItem.Status?.Data} />
    </td>
  );
};

const CustomPriorityCell = (dataItem) => {
  return (
    <FluentTooltip
      target={
        <td className="k-table-td td-priority no-pointer">
           <PriorityFluentNew priority={dataItem?.Priority?.SearchableData} /> 
        </td>
      }
      text={dataItem?.Priority?.SearchableData}
    />
  );
};

const CustomAssignedMembersCell = (dataItem) => {
  return (
    <td className="k-table-td">
      <TaskGridViewMembers
        taskCreator={dataItem.CreatedBy?.Data}
        dataItemType={dataItem.TaskTypeId?.Data}
        UserID={dataItem.CreatedById?.Data}
        members={dataItem["Assigned Members"]?.Data}
        groups={dataItem.Groups?.Data}
      />
    </td>
  );
};

const CustomMembersCell = (dataItem, column) => {
  // Handle both "Members" and "Team" column names
  const membersData = dataItem[column]?.Data || dataItem.Members?.Data || dataItem.Team?.Data;
  
  return (
    <td className="k-table-td">
      <TaskGridViewMembers
        taskCreator={dataItem.CreatedBy?.Data}
        dataItemType={dataItem.TaskTypeId?.Data}
        UserID={dataItem.CreatedById?.Data}
        members={membersData}
        groups={dataItem.Groups?.Data}
      />
    </td>
  );
};

const CustomOwnerCell = (dataItem) => {
  return (
    <td className="k-table-td">
      <Owner dataItem={dataItem} />
    </td>
  );
};

const CustomLastActivityCell = (dataItem) => {
  return (
    <FluentTooltip
      target={
        <td className="k-table-td">
          <LastActivity dataItem={dataItem} />
        </td>
      }
      text={<LastActivity dataItem={dataItem} />}
    />
  );
};

const CustomProgressCell = (dataItem) => {
  return (
    <FluentTooltip
      target={
        <td className="k-table-td">
          <Progress dataItem={dataItem} />
        </td>
      }
      text={ `${dataItem?.Progress?.Data ?? 0}%` }
    />
  );
};

const CustomDateCell = (date) => {
  return (
    <FluentTooltip
      target={<td className="k-table-td">{date.SearchableData}</td>}
      text={date.SearchableData}
    />
  );
};

export const CustomActionsCell = ({ dataItem }, GetTasks) => {
  return (
    <td className="k-table-td td-actions">
      <TaskActions
        taskId={dataItem.Id?.Data}
        refreshTasks={GetTasks}
      />
    </td>
  );
};

export const HeaderCustomCell = (props, user) => {
  return (
    props.tdProps && (
      <td {...props.tdProps}>
        {props.children && (
          <p className="k-reset">
            {props.children.props.children[0]}
            {props.dataItem.field === "Start.Data" || props.dataItem.field === "Due.Data"
              ? DateStringFormatBasedOnDepartment(
                  props.dataItem.value,
                  user?.currentUser?.department?.DateFormatID
                )
              : props.dataItem.value}
          </p>
        )}
      </td>
    )
  );
};
